module.exports = __webpack_public_path__ + "static/media/street_4pols_20170323.eb1cdffd.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/street_4pols_20170323.png
// module id = 296
// module chunks = 0